<script>
  export let size = 16;
  export let title = undefined;
  /** Color of the bar; the letter inherits the surrounding text color. */
  export let barColor = "currentColor";

  $: labelled = $$props["aria-label"] || $$props["aria-labelledby"] || title;
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0 ? true : undefined,
  };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  fill="currentColor"
  preserveAspectRatio="xMidYMid meet"
  width="{size}"
  height="{size}"
  {...attributes}
  {...$$restProps}
>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M14.5 4h3L25 23h-3.2l-1.9-5H12l-1.9 5H7L14.5 4Zm-1.4 11h5.7L16 7.5 13.1 15Z"
  ></path>
  <rect x="4" y="26" width="24" height="4" rx="1" fill="{barColor}"></rect>
</svg>
